/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./battle.vue?vue&type=template&id=97fd5610&scoped=true"
import script from "./battle.vue?vue&type=script&lang=js"
export * from "./battle.vue?vue&type=script&lang=js"
import style0 from "./battle.vue?vue&type=style&index=0&id=97fd5610&prod&lang=css"
import style1 from "./battle.vue?vue&type=style&index=1&id=97fd5610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fd5610",
  null
  
)

export default component.exports